import { EntityType } from '../../../../../../shared/models/entity-type.models'
import { Node } from 'reactflow'
import { BaseNodeData } from '../../base/types'
import { NodeTypes } from '../../../../../../shared/models/rule-node'

export interface ActionEntityOperationCreateConfiguration {
  entityType: EntityType
  prefixNamePattern: string
  entityNamePattern: string
  nameKey: string
  idKey: string
}

interface Props {
  onSubmit: (
    data: Node<
      BaseNodeData<ActionEntityOperationCreateConfiguration>,
      NodeTypes.ACTION_ENTITY_OPERATION_CREATE
    >
  ) => void
  defaultValues: Node<
    BaseNodeData<ActionEntityOperationCreateConfiguration>,
    NodeTypes.ACTION_ENTITY_OPERATION_CREATE
  >
}

const ActionEntityOperationCreateForm = ({
  onSubmit,
  defaultValues,
}: Props) => {
  return (
    <div>
      <h1>ActionEntityOperationCreate</h1>
    </div>
  )
}

export default ActionEntityOperationCreateForm
